// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:13:38

export default {
  "id": "merge-balls-new-years-toys-in-3d",
  "slug": "merge-balls-new-years-toys-in-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/40918c055dce4c7291a51f339389bc02-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/40918c055dce4c7291a51f339389bc02/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Balls New Years Toys in 3D!",
      "description": "● A game with a New Year's atmosphere! Compete with friends and colleagues?! In the game you have a play area? where balls fall and connect if they have the same color! Connect as many balls as possible to make the biggest one, save up points?! Be the first on the leaderboard?! Play and relax ?!",
      "instructions": "1. At first it will be easy to connect the balls?, but over time there will be more and more of them??. Once you connect the biggest ball in this game, it will disappear? and give you the most points?! If one of the balls touches the line and lies on it for some time, then you will lose?, and the game will start again?!\n2. Press and hold your finger or mouse to control the ball. Release your finger or mouse button to let the ball fall onto the field?!\n3. Enjoy the game?!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "3d"
      ]
    },
    "zh-CN": {
      "title": "《3D新年玩具融合球》",
      "description": "● 具有新年氛围的游戏！与朋友和同事竞争？！在游戏中，你有一个游戏区域？球会下落，如果颜色相同则连接！连接尽可能多的球，形成最大的球，积累分数？！成为排行榜第一？！玩游戏，放松一下？！",
      "instructions": "1. 起初连接球会很容易，但随着时间的推移，球会越来越多。一旦你连接了游戏中最大的球，它将会消失并给你最多的分数！如果其中一个球触碰到线并停留在上面一段时间，那么你将会失败，游戏将重新开始！\n2. 按住你的手指或鼠标来控制球。释放手指或鼠标按钮，让球落在场地上！\n3. 享受游戏吧？！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "3D"
      ]
    },
    "zh-TW": {
      "title": "Merge Balls 新年玩具3D版！",
      "description": "● 一款充滿新年氣氛的遊戲！與朋友和同事競賽？！在遊戲中你有一個遊戲區域？裡面會掉落下球體，如果它們顏色相同就會連接！盡可能多地連接球體，以形成最大的球體，累積分數？！成為領先板上的第一人？！遊戲並放鬆？！",
      "instructions": "1. 起初將球連結起來會很簡單，但隨著時間的推移，會有越來越多的球出現。一旦你連結遊戲中最大的球，它就會消失並給你最多的分數！如果有一個球觸碰到線並在線上停留一段時間，那麼你將會輸，遊戲將重新開始！\n2. 按住你的手指或滑鼠來控制球。放開手指或滑鼠按鈕讓球落到場地上！\n3. 享受遊戲吧？！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1人遊玩",
        "3D"
      ]
    },
    "zh-HK": {
      "title": "Merge Balls 新年玩具3D版！",
      "description": "● 具有新年氣氛的遊戲！與朋友和同事競賽？！遊戲中你有一個遊戲區域？裡面會掉落球體，如果它們顏色相同就會連接！盡可能多地連接球體，以製造最大的球，累積分數？！成為排行榜上的第一人？！遊戲並放鬆？！",
      "instructions": "1. 起初連接球會很簡單，但隨著時間的推移，會有越來越多的球？一旦你連接遊戲中最大的球，它就會消失？並給你最多的分數？！如果其中一個球觸碰到線並在線上躺一會兒，那麼你就會輸？遊戲將重新開始?!\n2. 按住你的手指或滑鼠來控制球。釋放手指或滑鼠按鈕，讓球掉落到場地上?!\n3. 欣賞遊戲？！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1人遊玩",
        "3D"
      ]
    },
    "ja": {
      "title": "マージボールズ 新年のおもちゃ3D！",
      "description": "● 新年気分満載のゲーム！友人や同僚と競争してみませんか？ゲーム内には、色が同じボールが落ちて連結するプレイエリアがあります！できるだけ多くのボールを連結して最大のボールを作り、ポイントを積み重ねてください！リーダーボードで最初になるために遊びながらリラックスしてください！",
      "instructions": "1. 最初はボールを結ぶのが簡単ですが、時間が経つにつれてどんどん増えていきます。このゲームで最大のボールを結んだら、それが消え去り、最高のポイントを獲得します！ボールがラインに触れ、その上に少し留まると、あなたは負け、ゲームが再開されます！\n2. ボールを操作するには、指やマウスを押し続けます。指やマウスボタンを離すと、ボールがフィールドに落下します！\n3. ゲームを楽しんでください！",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "3D"
      ]
    },
    "ko": {
      "title": "3D!Merge Balls 신해 볼즈",
      "description": "● 새해 분위기가 가득한 게임! 친구들과 동료들과 경쟁하세요?! 게임에서 플레이 영역이 있어서 같은 색의 볼들이 떨어지고 연결됩니다! 가능한 많은 볼을 연결하여 가장 큰 볼을 만들고 점수를 모으세요?! 리더보드에서 최초로되세요?! 놀고 편하게하세요?!",
      "instructions": "1. 원래는 볼을 연결하는 것이 쉬울 것 같지만, 시간이 지나면서 볼이 점점 더 많아질 것입니다. 이 게임에서 가장 큰 볼을 연결하면 그 볼이 사라지고 가장 많은 점수를 주게 됩니다! 어떤 볼이 선에 닿고 그 위에 언제나 있으면, 당신은 게임을 잃게 되고 게임이 다시 시작됩니다!\n2. 볼을 제어하려면 손가락이나 마우스를 누르고 지속하세요. 손가락이나 마우스 버튼을 떼어 볼이 필드에 떨어지게 하세요!\n3. 게임을 즐겨보세요?!",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "3D"
      ]
    },
    "fr": {
      "title": "Mélanger les Billes de Nouvel An en 3D !",
      "description": "● Un jeu avec une ambiance de Nouvel An ! Compete avec des amis et des collègues ?! Dans le jeu, vous avez une zone de jeu ? où des balles tombent et se connectent si elles ont la même couleur ! Connectez le plus de balles possible pour faire le plus grand, accumulez des points ?! Soyez le premier sur le classement ?! Jouez et détendez-vous ?!",
      "instructions": "1. Au début, il sera facile de connecter les balles, mais au fil du temps, il y en aura de plus en plus de balles?. Une fois que vous avez connecté la plus grande balle dans ce jeu, elle disparaitra? et vous donnera le plus de points?! Si l'une des balles touche la ligne et reste sur elle pendant un certain temps, alors vous perdrez?, et le jeu recommencera?!\n2. Appuyez et tenez votre doigt ou la souris pour contrôler la balle. Relâchez le bouton de votre doigt ou la souris pour laisser la balle tomber sur le champ?!\n3. Profitez du jeu?!",
      "genres": [
        "Accordéon"
      ],
      "tags": [
        "1 joueur",
        "3D"
      ]
    }
  }
};
